import React from 'react';
import SecondDescription from './V2';
import MainDescription from './MainDescription';

export const Description = () => {
  return (
    <div>
        <SecondDescription />
        <MainDescription />
    </div>
  );
};
